module.exports = require('buffer')



//////////////////
// WEBPACK FOOTER
// ../~/safe-buffer/browser.js
// module id = 22
// module chunks = 0